/**
 * FAMILY'S — Fonctionnalités en STANDBY (côté back-office web).
 *
 * MIROIR de `functions/featureStandby.js`. Le serveur reste la porte qui
 * COMPTE ; ce fichier évite d'afficher à l'administrateur un panneau dont
 * toutes les actions seraient refusées.
 *
 * POUR RALLUMER : passer à `false` ICI **et** dans `functions/featureStandby.js`,
 * puis redéployer les fonctions concernées.
 */

export const STANDBY_FEATURES = {
  // Génération/validation de modèles 3D (Meshy) — en veille (2026-08-23).
  ar3d: true,
  voice_order: true,
};

export const isStandby = (feature) => STANDBY_FEATURES[feature] === true;

export default STANDBY_FEATURES;
